import axios from 'axios';

import { toast } from 'components/elements/molecules/Toast/Toast';
import { updatePropagateStatus } from './classRooms';

export const LOAD_COURSE_GRADES = 'LOAD_COURSE_GRADES';
export const UPDATE_COURSE_GRADES = 'UPDATE_COURSE_GRADES';
export const UPDATE_COURSE_GRADES_EVALUATING_STATUS =
  'UPDATE_COURSE_GRADES_EVALUATING_STATUS';
export const LOAD_COURSE_GOAL_OPTIONS = 'LOAD_COURSE_GOAL_OPTIONS';
export const UPDATE_SETTING_FOR_STUDENT = 'UPDATE_SETTING_FOR_STUDENT';
export const LOAD_COURSE_GRADE_GOALS_PROGRESS_CURRENT_WEEK =
  'LOAD_COURSE_GRADE_GOALS_PROGRESS_CURRENT_WEEK';

export function loadCourseGrades(courseId, courseGrades) {
  return {
    type: LOAD_COURSE_GRADES,
    courseId,
    courseGrades,
  };
}

export function updateCourseGrades(courseId, courseGrades) {
  return {
    type: UPDATE_COURSE_GRADES,
    courseId,
    courseGrades,
  };
}

export function updateCourseGradesEvaluatingStatus(courseId) {
  return {
    type: UPDATE_COURSE_GRADES_EVALUATING_STATUS,
    courseId,
  };
}

export function updateSettingForStudent(courseId, showGradesToStudents) {
  return {
    type: UPDATE_SETTING_FOR_STUDENT,
    courseId,
    showGradesToStudents,
  };
}

export function loadCourseGoalOptions(courseGoalOptions) {
  return {
    type: LOAD_COURSE_GOAL_OPTIONS,
    courseGoalOptions,
  };
}

export function loadCourseGradeGoalsProgressCurrentWeek(
  courseGradeGoalsProgressCurrentWeek,
) {
  return {
    type: LOAD_COURSE_GRADE_GOALS_PROGRESS_CURRENT_WEEK,
    courseGradeGoalsProgressCurrentWeek,
  };
}

export function getCourseGrades(courseId) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/courseGrades/getCourseGrades', {
          params: {
            courseId,
          },
        })
        .then((response) => {
          const data = response.data.courseGrades;

          dispatch(loadCourseGrades(courseId, data));

          return resolve(data);
        })
        .catch((error) => {
          console.log('Error while getting course grades', error);

          return resolve();
        });
    });
  };
}

export function upsertCourseGrades(
  courseId,
  goals,
  totalPoints,
  calculateGrades,
) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const state = getState();
      const courseGradeExists = state.courseGrades.grades[courseId];

      axios
        .post('/api/courseGrades/upsertCourseGrades', {
          courseId,
          goals,
          totalPoints,
          calculateGrades,
        })
        .then((response) => {
          const data = response.data.courseGrades;

          dispatch(updateCourseGrades(courseId, data));
          dispatch(updatePropagateStatus(courseId, true));

          if (courseGradeExists) {
            toast(
              'We’ve updated your course grades. We’ll send you an email when your student grades are recalculated with these new rules.',
              {
                type: 'success',
              },
            );
          } else {
            toast('Course grades rules have been saved.', {
              type: 'success',
            });
          }

          return resolve(data);
        })
        .catch((error) => {
          console.log('Error while getting course grades', error);

          return resolve();
        });
    });
  };
}

export function getCourseGoalOptions() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const state = getState();
      const existingCourseGoalOptions = state.courseGrades.options;

      if (
        Array.isArray(existingCourseGoalOptions) &&
        existingCourseGoalOptions.length > 0
      ) {
        resolve(existingCourseGoalOptions);
      } else {
        axios
          .get(`/api/courseGrades/getCourseGoalOptions`)
          .then((response) => {
            const data = response.data.courseGoalOptions;

            dispatch(loadCourseGoalOptions(data));

            return resolve(data);
          })
          .catch((error) => {
            console.log('Error while getting course goal options', error);

            return resolve();
          });
      }
    });
  };
}

export function getCourseGradesOfStudents(courseId, filters) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/courseGrades/getCourseGradesOfStudents', {
          params: {
            courseId,
            ...filters,
          },
        })
        .then((response) => {
          const data = response.data;

          return resolve(data);
        })
        .catch((error) => {
          console.log('Error while getting course grades', error);

          return resolve();
        });
    });
  };
}

export function downloadCourseGrades(courseId, filters) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/courseGrades/downloadCourseGrades', {
          params: {
            courseId,
            ...filters,
          },
          responseType: 'blob',
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: 'text/csv' });
          const url = window.URL.createObjectURL(blob);

          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'course-grades.csv'); // filename
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url); // clean up

          return resolve();
        })
        .catch((error) => {
          console.log('Error while getting course grades', error);

          return resolve();
        });
    });
  };
}

export function updateCourseGradesSettingForStudent(
  courseId,
  showGradesToStudents,
) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/courseGrades/updateCourseGradesSettingForStudent', {
          courseId,
          showGradesToStudents,
        })
        .then((response) => {
          dispatch(updateSettingForStudent(courseId, showGradesToStudents));
          dispatch(updatePropagateStatus(courseId, true));

          return resolve();
        })
        .catch((error) => {
          console.log('Error while updating course grade setting', error);

          return resolve();
        });
    });
  };
}

export function getStudentsGrades(courseId) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/courseGrades/getStudentsGrades', {
          params: {
            courseId,
          },
        })
        .then((response) => {
          const data = response.data;

          return resolve(data);
        })
        .catch((error) => {
          console.log('Error while getting course grades', error);

          return resolve();
        });
    });
  };
}

export function getCourseGradeGoalsProgressForCurrentWeek() {
  return (dispatch) => {
    return axios
      .get('/api/courseGrades/getCourseGradeGoalsProgressForCurrentWeek')
      .then((res) => {
        dispatch(
          loadCourseGradeGoalsProgressCurrentWeek(res.data.courseGrades),
        );
      })
      .catch((error) => {
        console.log('Error while getting course grade goals progress', error);
      });
  };
}

export function recalculateCourseGrades(courseId) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/courseGrades/recalculateCourseGrades', {
          courseId,
        })
        .then((response) => {
          dispatch(updateCourseGradesEvaluatingStatus(courseId));

          toast(
            'We’ll send you an email when your student grades are recalculated.',
            {
              type: 'success',
            },
          );

          return resolve();
        })
        .catch((error) => {
          console.log('Error while recalculating course grades', error);

          toast(
            'Error while recalculating course grades. Please try again or contact admin if error persists.',
            {
              type: 'error',
            },
          );

          return resolve();
        });
    });
  };
}
